
export const typeProtocol = {

  methods: {
    isDTTProtocol: function(teachingMethod) {
      return teachingMethod == 1;
    },

    isSimpleProtocol: function(teachingMethod) {
      return teachingMethod == 2;
    },

    isMandProtocol: function(teachingMethod) {
      return teachingMethod == 3;
    },

    isUSDProtocol: function (teachingMethod) {
      return teachingMethod == 4;
    },

    isChainProtocol: function (teachingMethod) {
      return teachingMethod == 5;
    },

    isShapingProtocol(teachingMethod){
      return teachingMethod == 6
    },

    isPecsProtocol(teachingMethod){
      return teachingMethod == 7
    },

    isPecsWithoutDiscriminationProtocol(teachingMethod){
      return teachingMethod == 8
    },

    isPecsWithDiscriminationProtocol(teachingMethod){
      return teachingMethod == 9
    },

    isPecsWithItemsProtocol(teachingMethod){
      return teachingMethod == 10
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/mixins/typeMethodProtocol.js